import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import Box from "../Box";
import Img from "../Img";
import { useThemeDefaults } from "../utils";
export var Container = useThemeDefaults(function (_ref) {
  var theme = _ref.theme;
  return {
    display: theme.artwork.container.display,
    justifyContent: theme.artwork.container.justifyContent,
    alignItems: theme.artwork.container.alignItems,
    minWidth: theme.artwork.container.minWidth,
    width: theme.artwork.container.width,
    height: theme.artwork.container.height
  };
}, Box);
export var Circle = useThemeDefaults(function (_ref2) {
  var theme = _ref2.theme;
  return {
    width: theme.artwork.circle.width,
    height: theme.artwork.circle.height,
    objectFit: theme.artwork.circle.objectFit,
    borderRadius: theme.artwork.circle.borderRadius,
    border: theme.artwork.circle.border,
    borderColor: theme.artwork.circle.borderColor
  };
}, Img);
export var Square = useThemeDefaults(function (_ref3) {
  var theme = _ref3.theme;
  return {
    width: theme.artwork.square.width,
    height: theme.artwork.square.height,
    objectFit: theme.artwork.square.objectFit,
    borderRadius: theme.artwork.square.borderRadius,
    border: theme.artwork.square.border,
    borderColor: theme.artwork.square.borderColor
  };
}, Img);
export var Rectangle = useThemeDefaults(function (_ref4) {
  var theme = _ref4.theme;
  return {
    width: theme.artwork.rectangle.width,
    height: theme.artwork.rectangle.height,
    objectFit: theme.artwork.rectangle.objectFit,
    borderRadius: theme.artwork.rectangle.borderRadius,
    border: theme.artwork.rectangle.border,
    borderColor: theme.artwork.rectangle.borderColor
  };
}, Img);
export var Artwork = function Artwork(_ref5) {
  var props = _extends({}, _ref5);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, props));
};
Artwork.Circle = Circle;
Artwork.Square = Square;
Artwork.Rectangle = Rectangle;
export default Artwork;